(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["rgx-card-fitment"] && !Shopify.designMode) return;
  try {
    (function () {
    if (customElements.get('rgx-card-fitment')) return;
    function current() {
      try { return JSON.parse(localStorage.getItem('rgx.vehicle') || 'null'); } catch (e) { return null; }
    }
    class RgxCardFitment extends HTMLElement {
      connectedCallback() {
        this.render(current());
        this._h = (e) => this.render(e.detail);
        window.addEventListener('rgx:vehicle', this._h);
      }
      disconnectedCallback() { window.removeEventListener('rgx:vehicle', this._h); }
      render(v) {
        var tag = this.querySelector('.rgx-cf__fit');
        if (!tag) return;
        var ok = !!(v && v.g) && (this.dataset.keys || '').split(';').indexOf([v.m, v.d, v.g].join('|')) !== -1;
        tag.hidden = !ok;
      }
    }
    customElements.define('rgx-card-fitment', RgxCardFitment);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["rgx-fitment-status"] && !Shopify.designMode) return;
  try {
    (function () {
    if (customElements.get('rgx-fitment-status')) return;
    class RgxFitmentStatus extends HTMLElement {
      connectedCallback() {
        try { this.fits = JSON.parse(this.querySelector('[data-fs-data]').textContent); } catch (e) { this.fits = []; }
        this.text = this.querySelector('[data-fs-text]');
        this.hint = this.querySelector('[data-fs-hint]');
        this.btn = this.querySelector('[data-fs-open]');
        this.btn.addEventListener('click', () => window.dispatchEvent(new CustomEvent('rgx:open-selector')));
        var chat = this.querySelector('[data-fs-chat]');
        if (chat) chat.addEventListener('click', function () {
          var inbox = document.querySelector('inbox-online-store-chat');
          var b = inbox && inbox.shadowRoot && inbox.shadowRoot.querySelector('button');
          if (b) { b.click(); return; }
          var wa = chat.parentElement.querySelector('a[href*="wa.me"]');
          if (wa) window.open(wa.href, '_blank', 'noopener');
        });
        window.addEventListener('rgx:vehicle', (e) => this.render(e.detail));
        var v = null;
        try { v = JSON.parse(localStorage.getItem('rgx.vehicle') || 'null'); } catch (e) {}
        this.render(v);
      }
      render(v) {
        if (!v || !v.g) {
          this.dataset.state = 'none';
          this.text.textContent = this.dataset.ask;
          this.hint.hidden = true; this.btn.hidden = false;
          return;
        }
        var ok = this.fits.some(function (f) { return f.m === v.m && f.d === v.d && f.g === v.g; });
        this.dataset.state = ok ? 'ok' : 'no';
        this.text.textContent = (ok ? this.dataset.ok : this.dataset.no).replace('{vehicle}', v.label || (v.m + ' ' + v.g));
        this.hint.hidden = !ok;
        this.btn.hidden = ok;
      }
    }
    customElements.define('rgx-fitment-status', RgxFitmentStatus);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["rgx-linked"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.rgxLinkedInit) return;
    window.rgxLinkedInit = true;

    // Keep checkbox value, price, compare price and image in sync with the card's variant select
    document.addEventListener('change', function (event) {
      var select = event.target && event.target.closest && event.target.closest('.rgx-lk__variant');
      if (!select) return;
      var card = select.closest('.rgx-lk__card');
      var opt = select.options[select.selectedIndex];
      if (!card || !opt) return;
      var check = card.querySelector('.rgx-lk__check');
      if (check) check.value = opt.value;
      var price = card.querySelector('.rgx-lk__price');
      if (price && opt.dataset.price) price.textContent = opt.dataset.price;
      var cmp = card.querySelector('.rgx-lk__compare');
      if (cmp) { cmp.textContent = opt.dataset.compare || ''; cmp.hidden = !opt.dataset.compare; }
      var img = card.querySelector('.rgx-lk__media img');
      if (img && opt.dataset.image) { img.src = opt.dataset.image; img.removeAttribute('srcset'); }
    });

    // Add checked linked products first, then let Horizon add the main product as usual
    window.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
      if (!form.closest('product-form-component')) return;
      if (form.dataset.rgxLinkedPass === '1') { delete form.dataset.rgxLinkedPass; return; }

      var boxes = Array.prototype.slice.call(document.querySelectorAll('.rgx-lk__check:checked'));
      if (!boxes.length) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      var submitter = event.submitter || null;
      var items = boxes.map(function (b) { return { id: Number(b.value), quantity: 1 }; });
      var url = (window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add';

      fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ items: items })
      })
        .catch(function (err) { console.warn('[rgx-linked] add failed', err); })
        .finally(function () {
          boxes.forEach(function (b) { b.checked = false; });
          form.dataset.rgxLinkedPass = '1';
          if (form.requestSubmit) { submitter ? form.requestSubmit(submitter) : form.requestSubmit(); }
          else { form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true })); }
        });
    }, true);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["rgx-vehicle-selector"] && !Shopify.designMode) return;
  try {
    (function () {
    if (customElements.get('rgx-vehicle-selector')) return;
    var KEY = 'rgx.vehicle';
    var OTHER = '__other__';

    function readVehicle() {
      try { return JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) { return null; }
    }
    function saveVehicle(v) {
      try { localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) {}
      window.dispatchEvent(new CustomEvent('rgx:vehicle', { detail: v }));
    }
    function uniq(a) { return a.filter(function (v, i) { return a.indexOf(v) === i; }); }
    function el(tag, cls, text) {
      var n = document.createElement(tag);
      if (cls) n.className = cls;
      if (text != null) n.textContent = text;
      return n;
    }

    class RgxVehicleSelector extends HTMLElement {
      connectedCallback() {
        if (this._init) return;
        this._init = true;
        var data;
        try { data = JSON.parse(this.querySelector('[data-vs-data]').textContent); } catch (e) { return; }
        this.P = data.p || [];
        this.R = data.r || [];
        if (!this.R.length) return;
        var d = this.dataset;
        this.inPanel = !!this.closest('[data-vb-dialog]');
        this.priority = (d.priority || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
        this.selMake = this.querySelector('[data-vs-make]');
        this.selModel = this.querySelector('[data-vs-model]');
        this.selGen = this.querySelector('[data-vs-gen]');
        this.msg = this.querySelector('[data-vs-msg]');
        this.box = this.querySelector('[data-vs-results]');
        this.saved = this.querySelector('[data-vs-saved]');

        this.fill(this.selMake, d.phMake, this.makes(), true);
        this.selMake.addEventListener('change', () => this.onMake());
        this.selModel.addEventListener('change', () => this.onModel());
        this.selGen.addEventListener('change', () => this.onGen(true));

        /* v2: "Entfernen" in the bar fires rgx:vehicle with no vehicle -> empty everything here */
        window.addEventListener('rgx:vehicle', (e) => { if (!e.detail) this.clearAll(); });

        var v = readVehicle();
        if (d.preMake && this.makes().indexOf(d.preMake) !== -1) {
          this.selMake.value = d.preMake; this.onMake();
          if (d.preModel && this.models(d.preMake).indexOf(d.preModel) !== -1) {
            this.selModel.value = d.preModel; this.onModel();
            if (v && v.m === d.preMake && v.d === d.preModel && this.gens(v.m, v.d).indexOf(v.g) !== -1) {
              this.selGen.value = v.g; this.onGen(false);
            }
          }
        } else if (v && this.makes().indexOf(v.m) !== -1) {
          this.selMake.value = v.m; this.onMake();
          if (this.models(v.m).indexOf(v.d) !== -1) {
            this.selModel.value = v.d; this.onModel();
            if (this.gens(v.m, v.d).indexOf(v.g) !== -1) { this.selGen.value = v.g; this.onGen(false); }
          }
        }
      }

      fill(sel, ph, values, other) {
        sel.innerHTML = '';
        sel.appendChild(new Option(ph, ''));
        values.forEach(function (v) { sel.appendChild(new Option(v, v)); });
        if (other) sel.appendChild(new Option(this.dataset.other, OTHER));
      }
      makes() {
        var pr = this.priority;
        return uniq(this.R.map(function (r) { return r.m; })).sort(function (a, b) {
          var ia = pr.indexOf(a), ib = pr.indexOf(b);
          if (ia === -1) ia = 999; if (ib === -1) ib = 999;
          return ia - ib || a.localeCompare(b);
        });
      }
      models(m) {
        return uniq(this.R.filter(function (r) { return r.m === m; }).map(function (r) { return r.d; }))
          .sort(function (a, b) { return a.localeCompare(b, undefined, { numeric: true }); });
      }
      gens(m, d) {
        var rows = this.R.filter(function (r) { return r.m === m && r.d === d; });
        rows.sort(function (a, b) { return b.y - a.y; });
        return uniq(rows.map(function (r) { return r.g; }));
      }
      reset() { this.msg.hidden = true; this.msg.innerHTML = ''; this.box.hidden = true; this.box.innerHTML = ''; }
      clearAll() {
        this.selMake.value = '';
        this.fill(this.selModel, this.dataset.phModel, [], false); this.selModel.disabled = true;
        this.fill(this.selGen, this.dataset.phGen, [], false); this.selGen.disabled = true;
        this.reset();
        this.saved.hidden = true; this.saved.textContent = '';
      }

      onMake() {
        this.reset();
        var m = this.selMake.value;
        this.fill(this.selGen, this.dataset.phGen, [], false); this.selGen.disabled = true;
        if (m === OTHER) {
          this.fill(this.selModel, this.dataset.phModel, [], false); this.selModel.disabled = true;
          this.makeNone();
          return;
        }
        if (m) { this.fill(this.selModel, this.dataset.phModel, this.models(m), true); this.selModel.disabled = false; }
        else { this.fill(this.selModel, this.dataset.phModel, [], false); this.selModel.disabled = true; }
      }
      onModel() {
        this.reset();
        var m = this.selMake.value, d = this.selModel.value;
        if (d === OTHER) { this.none(m); this.fill(this.selGen, this.dataset.phGen, [], false); this.selGen.disabled = true; return; }
        if (d) { this.fill(this.selGen, this.dataset.phGen, this.gens(m, d), true); this.selGen.disabled = false; }
        else { this.fill(this.selGen, this.dataset.phGen, [], false); this.selGen.disabled = true; }
      }
      onGen(userAction) {
        this.reset();
        var m = this.selMake.value, d = this.selModel.value, g = this.selGen.value;
        if (!g) return;
        if (g === OTHER) { this.none([m, d].join(' ')); return; }
        var hits = this.R.filter(function (r) { return r.m === m && r.d === d && r.g === g; });
        var byIdx = {}, list = [], P = this.P;
        hits.forEach(function (r) {
          if (!P[r.x]) return;
          if (!byIdx.hasOwnProperty(r.x)) { byIdx[r.x] = { p: P[r.x], q: [] }; list.push(byIdx[r.x]); }
          if (r.q && byIdx[r.x].q.indexOf(r.q) === -1) byIdx[r.x].q.push(r.q);
        });
        var label = [m, g].join(' ');
        saveVehicle({ m: m, d: d, g: g, label: label });
        this.showSaved(label);
        if (!list.length) { this.none(label); return; }
        if (list.length === 1 && userAction && !this.inPanel) { window.location.href = list[0].p.u; return; }
        list.sort(function (a, b) { return a.p.k === b.p.k ? 0 : (a.p.k === 'h' ? -1 : 1); });
        this.results(label, list);
      }
      showSaved(label) {
        this.saved.textContent = this.dataset.saved + ' ' + label;
        this.saved.hidden = false;
      }
      none(label) {
        var href = this.dataset.contact + '?build=' + encodeURIComponent(label) +
          (this.selMake.value && this.selMake.value !== OTHER ? '&make=' + encodeURIComponent(this.selMake.value) : '') +
          (this.dataset.lights ? '&lights=' + encodeURIComponent(this.dataset.lights) : '');
        this.msg.innerHTML = '';
        this.msg.appendChild(document.createTextNode(this.dataset.msgNone + ' '));
        this.msg.appendChild(el('strong', null, label));
        this.msg.appendChild(document.createTextNode(' — '));
        var a = el('a', null, this.dataset.msgCta + ' →'); a.href = href;
        this.msg.appendChild(a);
        this.msg.hidden = false;
      }
      makeNone() {
        var d = this.dataset;
        var href = d.contact + (d.lights ? '?lights=' + encodeURIComponent(d.lights) : '');
        this.msg.innerHTML = '';
        this.msg.appendChild(document.createTextNode((d.msgMake || '') + ' — '));
        var a = el('a', null, d.msgCta + ' →'); a.href = href;
        this.msg.appendChild(a);
        this.msg.hidden = false;
      }
      results(label, list) {
        var KIND = { h: this.dataset.labelHead, t: this.dataset.labelTail };
        this.box.innerHTML = '';
        this.box.appendChild(el('p', 'rgx-vs__results-head',
          this.dataset.msgResults.replace('{count}', list.length).replace('{vehicle}', label)));
        var ul = el('ul', 'rgx-vs__hits');
        list.forEach(function (h) {
          var li = document.createElement('li');
          var a = el('a', 'rgx-vs__hit'); a.href = h.p.u;
          var media = el('span', 'rgx-vs__hit-media');
          if (h.p.i) { var img = new Image(72, 72); img.src = h.p.i; img.alt = ''; img.loading = 'lazy'; media.appendChild(img); }
          a.appendChild(media);
          var body = el('span', 'rgx-vs__hit-body');
          body.appendChild(el('span', 'rgx-vs__hit-kind', KIND[h.p.k] || ''));
          body.appendChild(el('span', 'rgx-vs__hit-title', h.p.t));
          if (h.q.length) body.appendChild(el('span', 'rgx-vs__hit-note', h.q.join(' · ')));
          if (h.p.p) body.appendChild(el('span', 'rgx-vs__hit-price', h.p.p));
          a.appendChild(body);
          a.appendChild(el('span', 'rgx-vs__hit-arrow', '›'));
          li.appendChild(a); ul.appendChild(li);
        });
        this.box.appendChild(ul);
        this.box.hidden = false;
        if (!this.inPanel && window.innerWidth < 750) {
          var top = this.box.getBoundingClientRect().top;
          if (top > window.innerHeight * 0.55) window.scrollBy({ top: top - 80, behavior: 'smooth' });
        }
      }
    }
    customElements.define('rgx-vehicle-selector', RgxVehicleSelector);
  })();
  } catch(e) { console.error(e); }
})();

})();
